import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 1000
    }
  }
});

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient;
  }
}

// Setup tanstack query devtools for debugging
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

export const invalidateQuery = (queryKey: string[]) => {
  queryClient.invalidateQueries({
    queryKey
  });
};

export const refetchQuery = (queryKey: string[]) => {
  queryClient.refetchQueries({ queryKey });
};
